import { PropsWithChildren, useRef } from 'react'

import {
  ReadyExperimentValue,
  UndefinedExperimentValue
} from '@/global/store/useExperimentStore'
import { useSimulationReducer, useStepReducer } from '@/modules/simulator/hooks'
import {
  SimulatorContext,
  SimulatorDispatchContext
} from '@/modules/simulator/contexts'

interface SimulatorProviderProps {
  simulatorVersion: ReadyExperimentValue | UndefinedExperimentValue
}

const SimulatorProvider = ({
  children,
  simulatorVersion
}: PropsWithChildren<SimulatorProviderProps>) => {
  const { step, stepDispatch } = useStepReducer()
  const { simulation, simulationDispatch } = useSimulationReducer()
  const simulatorWrapperRef = useRef<HTMLDivElement>(null)

  return (
    <SimulatorDispatchContext.Provider
      value={{ stepDispatch, simulationDispatch }}
    >
      <SimulatorContext.Provider
        value={{ simulatorVersion, step, simulation, simulatorWrapperRef }}
      >
        {children}
      </SimulatorContext.Provider>
    </SimulatorDispatchContext.Provider>
  )
}

export { SimulatorProvider }
export type { SimulatorProviderProps }
